/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './bed.reducer';

export const BedDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bedEntity = useAppSelector(state => state.bed.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bedDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bed.detail.title">Bed</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bed.id">Id</Translate>
            </span>
          </dt>
          <dd>{bedEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.bed.name">Name</Translate>
            </span>
          </dt>
          <dd>{bedEntity.name}</dd>
          <dt>
            <span id="bedNumber">
              <Translate contentKey="tinyMedicRestApp.bed.bedNumber">Bed Number</Translate>
            </span>
          </dt>
          <dd>{bedEntity.bedNumber}</dd>
          <dt>
            <span id="tempClosed">
              <Translate contentKey="tinyMedicRestApp.bed.tempClosed">Temp Closed</Translate>
            </span>
          </dt>
          <dd>{bedEntity.tempClosed ? 'true' : 'false'}</dd>
          <dt>
            <span id="dateClosed">
              <Translate contentKey="tinyMedicRestApp.bed.dateClosed">Date Closed</Translate>
            </span>
          </dt>
          <dd>{bedEntity.dateClosed}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.bed.description">Description</Translate>
            </span>
          </dt>
          <dd>{bedEntity.description}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.bed.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{bedEntity.modifiedBy}</dd>
          <dt>
            <span id="modifiedTime">
              <Translate contentKey="tinyMedicRestApp.bed.modifiedTime">Modified Time</Translate>
            </span>
          </dt>
          <dd>{bedEntity.modifiedTime}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.bed.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{bedEntity.createdBy}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bed.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bedEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.bed.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{bedEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.bed.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{bedEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bed.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bedEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bed.active">Active</Translate>
            </span>
          </dt>
          <dd>{bedEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.bed.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{bedEntity.charge}</dd>
          <dt>
            <span id="chargeType">
              <Translate contentKey="tinyMedicRestApp.bed.chargeType">Charge Type</Translate>
            </span>
          </dt>
          <dd>{bedEntity.chargeType}</dd>
          <dt>
            <span id="allotted">
              <Translate contentKey="tinyMedicRestApp.bed.allotted">Allotted</Translate>
            </span>
          </dt>
          <dd>{bedEntity.allotted ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bed.room">Room</Translate>
          </dt>
          <dd>{bedEntity.room ? bedEntity.room.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/bed" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/bed/${bedEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BedDetail;
